export default __webpack_public_path__ + "ae6b7110460e84c4eb1c520cdcadc1ce.png";